module.exports = __webpack_public_path__ + "static/img/log-title.7777e304.png";